import { Text, TextAlign, TextColor, TextSize } from 'shared/ui/Text/Text'
import cls from './Credits.module.scss'
import { classNames } from 'shared/lib/classNames/classNames'

export const Credits = (props) => {
    const { mode, margin, className, style } = props

    const mods = {
        [cls.short]: mode === 'short',
        [cls.margin]: margin,
    }

    return (
        <div
            style={style}
            className={classNames(cls.Credits, mods, [className])}
        >
            {mode !== 'short' ? (
                <Text
                    className={cls.CreditsText}
                    color={TextColor.TERBLACK}
                    align={TextAlign.LEFT}
                    size={TextSize.XS}
                >
                    <nav
                        className={cls.LegalLinks}
                        aria-label="Правовая информация"
                    >
                        <a href="/terms" className={cls.LegalLink}>
                            Пользовательское соглашение
                        </a>
                        <a href="/privacy" className={cls.LegalLink}>
                            Политика конфиденциальности
                        </a>
                    </nav>
                </Text>
            ) : null}
            <Text
                className={classNames(cls.CreditsText, {}, [cls.VersionBlock])}
                color={TextColor.TERBLACK}
                align={mode === 'short' ? TextAlign.CENTER : TextAlign.RIGHT}
                size={TextSize.XS}
            >
                {mode === 'short' ? (
                    <div className={cls.version}>MineCards v2.0 © 2026</div>
                ) : (
                    <>
                        <div className={cls.version}>MineCards v2.0</div>
                        <div>© 2026</div>
                    </>
                )}
            </Text>
        </div>
    )
}
